goog.provide("shadow.js.shim.module$$mui$x_license");
goog.provide("module$shadow_js_shim_module$$mui$x_license");
shadow.js.shim.module$$mui$x_license = shadow.js.nativeProvides["@mui/x-license"] = shadow$bridge("@mui/x-license");
module$shadow_js_shim_module$$mui$x_license.default = shadow.js.shim.module$$mui$x_license;
